import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const CommitteesPage = () => {
  const [committees, setCommittees] = useState([]);

  useEffect(() => {
    fetchCommittees();
  }, []);

  const fetchCommittees = async () => {
    try {
      const response = await axios.get(`${API}/committees`);
      setCommittees(response.data);
    } catch (error) {
      console.error('Failed to fetch committees:', error);
    }
  };

  const groupByLevel = (comms) => {
    return comms.reduce((acc, comm) => {
      if (!acc[comm.level]) acc[comm.level] = [];
      acc[comm.level].push(comm);
      return acc;
    }, {});
  };

  const grouped = groupByLevel(committees);

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif font-bold text-5xl text-primary mb-6 text-center">Committee Structure</h1>
        <p className="text-xl text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          Our hierarchical governance structure ensuring representation at all levels
        </p>

        {['central', 'state', 'district'].map((level) => (
          <div key={level} className="mb-12">
            <h2 className="font-serif font-bold text-3xl text-secondary mb-6 capitalize">{level} Level</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {(grouped[level] || []).map((committee) => (
                <div key={committee.id} className="bg-card p-6 rounded-xl shadow-card border border-border">
                  <h3 className="font-serif font-bold text-xl text-foreground mb-2">{committee.name}</h3>
                  {committee.location && (
                    <p className="text-sm text-muted-foreground mb-3">{committee.location}</p>
                  )}
                  <p className="text-muted-foreground">{committee.description}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommitteesPage;
